import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import * as React from 'react';

import './style.scss';

export interface IButtonLounge {
  title: string;
  action?: any;
  icon?: any;
  style: any;
  type?: any;
  disabled?: any;
  loading?: boolean;
  img?: any;
  backButton?: any;
}

export const ButtonLounge = ({ title, action, icon, style, type, disabled, loading, img, backButton = false }: IButtonLounge) => {

  return (
    <Button onClick={action} variant="contained" disabled={disabled || loading} className={'btnRadius ' + (loading ? `btnStyle${style} btnStyle1Disable` : `btnStyle${style}`)} type={type}  >
      {loading && <CircularProgress className='loading-button' color="primary" size={20} />}

      {!backButton && title}{" "}{icon}{" "}{img && <img src={img} className="p-1 img" />}
      {backButton && <ArrowBackIcon />}
    </Button>

  );
};
